import { Box } from '@mui/material';
import React, { useState } from 'react';

import { spaces } from '../../../../assets/styles/themes/tokens';
import AIAssistantToggler from '../../../AIAssistant/Dialog/AIAssistantToggler';
import SearchBar from '../../../SearchBar/SearchBar';
import SwipeableDrawer from '../../../SwipeableDrawer';
import NavIcon from '../../SideNavbar/NavIcon';

const containerStyles = {
	display: 'flex',
	flex: 1,
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'flex-end',
};

interface MobileTopBarProps {
	shouldShowAIAssistantToggler?: boolean;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({ shouldShowAIAssistantToggler = false }) => {
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
	const handleCloseDrawer = () => {
		setIsDrawerOpen(false);
	};

	return (
		<Box sx={containerStyles}>
			<NavIcon icon="searchNormal" onClick={() => setIsDrawerOpen(true)} />
			<SwipeableDrawer open={isDrawerOpen} onClose={handleCloseDrawer}>
				<SearchBar closeDrawer={handleCloseDrawer} />
			</SwipeableDrawer>
			<Box sx={{ marginLeft: spaces.xs }}>
				{shouldShowAIAssistantToggler && <AIAssistantToggler />}
			</Box>
		</Box>
	);
};

export default MobileTopBar;
